/**
 * @file
 * Header/banner search box behaviors for layerone.
 *
 * Requires global.js to be loaded first (Drupal.layerone.getScreenWidth).
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneSearch = {
    attach: function (context, settings) {

      sessionStorage.setItem('main-search-box', 'no-display');

      // Show sidebar for filters
      let searchBanner = $('.search-banner');
      if (searchBanner.length > 0) {
        let element = $('[data-drupal-selector="views-exposed-form-search-asqa-page-1"]', context);
        element.find('.button-wrapper input').attr('value', 'Search');
        let input = $('[data-drupal-selector="edit-search-api-fulltext"]').val();
        let searchText = $('#search-text');
        if (searchText.length > 0) {
          searchText[0].textContent = input;
        }
        element.appendTo('#banner > .container');
      }

      function getHeaderSearchOpacity() {
        let mainSearch = $('#page-layerone-views-block-search-page-1');
        if (mainSearch.length > 0) {
          $(mainSearch).find('.button-wrapper input').attr('value', '');
        }
        let header = $('#block-layerone-views-block-search-block-1');
        let headerInput = $('#block-layerone-views-block-search-block-1 .input-wrapper input');
        if (headerInput.length > 0 && header.length > 0) {
          $(header).find('.button-wrapper input').attr('value', '');
          let inputId = headerInput.attr('id');
          var input = document.getElementById(inputId);
          var opacity = window.getComputedStyle(input).getPropertyValue("opacity");
          return opacity;
        }
        else {
          return '0';
        }
      }

      function mainSearchResize() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let opacity = getHeaderSearchOpacity();

          if (screenWidth < 768 && opacity === '1') {
            let headerInput = $('#block-layerone-views-block-search-block-1 .input-wrapper input');
            if (headerInput.val() === '') {
              $(headerInput)
                .css('opacity', '0')
                .css('z-index', '-1');
            } else {
              $('#main-header-logo')
                .css('opacity', '0')
                .css('z-index', '-2');

            }

          }
          else if (screenWidth < 768 && opacity === '0') {
            $('#main-header-logo')
              .css('opacity', '1')
              .css('z-index', '1');


          } else {
            $('#block-layerone-views-block-search-block-1 .input-wrapper input')
              .css('opacity', '1')
              .css('z-index', '3');
            $('#main-header-logo')
              .css('opacity', '1')
              .css('z-index', '1');
          }
      }

      $('#block-layerone-views-block-search-block-1 .button-wrapper input').click(function(e) {
        let headerInput = $('#block-layerone-views-block-search-block-1 .input-wrapper input');
        let opacity = getHeaderSearchOpacity();
        if (opacity === '0') {
          e.preventDefault();
          e.stopPropagation();
          let screenWidth = Drupal.layerone.getScreenWidth();
          if (screenWidth < 768) {
            $('#main-header-logo')
              .css('opacity', '0')
              .css('z-index', '-2');
          } else if (screenWidth < 630) {

          }
          headerInput.css('opacity', '1').focus();
          sessionStorage.setItem('main-search-box', 'displayed');
        } else {
            if (headerInput.val() === '') {
              e.preventDefault();
              e.stopPropagation();
              headerInput.css('opacity', '1').focus();
              sessionStorage.setItem('main-search-box', 'displayed');
            }
            // No focus.
        }

      });

      $('#block-layerone-views-block-search-block-1 .input-wrapper input').focusout(function(e) {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let debug = false;
        if (screenWidth < 992 && !debug) {
          const sessionData = sessionStorage.getItem('main-search-box');
          if (sessionData === 'no-display') {
            $(this).css('opacity', '0');
            $('#main-header-logo').css('opacity', '1').css('z-index', '1');
            sessionStorage.setItem('main-search-box', 'no-display');
          }
        }

      });

      $('#header .block-views-blocksearch-asqa-block-1', context).find('.button-wrapper input').attr('value', 'Search');
      $('#header .block-views-blocksearch-asqa-block-1, #block-layerone-mainpagecontent .view-search-asqa', context).find('form').attr('action', '/search-asqa');

      function headerSearchButton() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let headerButton = $('#header .view-search-asqa .button-wrapper input', context);
        if (screenWidth < 992) {
          if (headerButton.hasClass('btn-primary')) {
            headerButton.removeClass('btn-primary').addClass('btn-secondary');
            headerButton.data('background', 'bg-white');
            headerButton.data('background-hover', 'bg-light-blue-tint-15');
          }
          if (headerButton.hasClass('bg-dark-blue-hero')) {
            headerButton.removeClass('bg-dark-blue-hero');
          }
        } else {
          if (headerButton.hasClass('btn-secondary')) {
            headerButton.removeClass('btn-secondary').addClass('btn-primary');
            headerButton.data('background', 'bg-dark-blue-hero');
            headerButton.data('background-hover', 'bg-dark-blue-shade');
          }
          if (headerButton.hasClass('bg-white')) {
            headerButton.removeClass('bg-white');
          }
        }
      }

      headerSearchButton();
      mainSearchResize();

      window.addEventListener('resize', function(){
        headerSearchButton();
        mainSearchResize();
      },true);

    }
  };

})(jQuery, Drupal);
